module.exports = __webpack_public_path__ + "img/meditation.28f2bfc2.jpg";